module.exports = __webpack_public_path__ + "img/upload-icon.af8234b4.svg";